// extracted by mini-css-extract-plugin
export default {"child":"Teaser_child__2K5qR","container":"Teaser_container__bWoiS"};